// frontend/src/contexts/LanguageContext.jsx - COMPLETE TRANSLATIONS VERSION
import React, { createContext, useContext, useState, useEffect } from 'react';

// Complete translation object with all missing translations
const translations = {
  en: {
    // Navigation & UI
    dashboard: 'Dashboard',
    myRenders: 'My Renders',
    newRender: 'New Render',
    settings: 'Settings',
    signOut: 'Sign Out',
    analytics: 'Analytics',
    upload: 'Upload',
    profile: 'Profile',
    
    // Authentication
    signIn: 'Sign In',
    signUp: 'Sign Up',
    createAccount: 'Create Account',
    email: 'Email Address',
    password: 'Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    youtubeChannel: 'YouTube Channel',
    optional: 'Optional',
    min6chars: 'minimum 6 characters',
    
    // Common phrases
    toRenderStudio: 'to Render Studio',
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    backToHome: 'Back to home',
    signingIn: 'Signing in...',
    creatingAccount: 'Creating account...',
    confirmLogout: 'Are you sure you want to sign out?',
    freePlan: 'Free Plan',
    
    // Connection and errors
    testConnection: 'Test Connection',
    runConnectionTest: 'Run Connection Diagnostics',
    connectionDiagnostics: 'Connection Diagnostics',
    connectionIsWorkingWell: 'Connection is working well',
    someConnectionIssuesDetected: 'Some connection issues detected',
    multipleConnectionProblems: 'Multiple connection problems',
    connectionTestFailed: 'Connection test failed',
    testingConnection: 'Testing connection...',
    connectionStatusUnknown: 'Connection status unknown',
    
    // Subscription benefits
    byCreatingAccount: 'By creating an account, you get',
    '3FreeRenders': '3 free renders per month',
    '1080pResolution': '1080p resolution',
    standardQueue: 'Standard queue priority',
    accessToUpgrade: 'Access to upgrade plans',

    // Landing Page
    welcome: 'Welcome to Render Studio',
    professional: 'Professional',
    rendering: '3D Rendering',
    inTheCloud: 'in the Cloud',
    heroSubtitleLanding: 'Transform your Blender projects into stunning animations with our powerful cloud rendering platform. No expensive hardware. No waiting. Just results.',
    startRenderingFree: 'Start Rendering Free',
    watchDemo: 'Watch Demo',
    noCreditCardRequired: 'No credit card required',
    includedFreeRenders: '3 free renders included',
    
    whyChooseRenderStudio: 'Why Choose Render Studio?',
    professionalToolsDescription: 'Professional tools, cloud power, simplified workflow',
    
    // Features
    features: 'Features',
    animationRendering: '3D Animation Rendering',
    animationRenderingDescription: 'Professional Blender rendering in the cloud. Upload your .blend files and get stunning results.',
    pricing: 'Pricing',
    contact: 'Contact',
    
    // Footer
    quickLinks: 'Quick Links',
    documentation: 'Documentation',
    support: 'Support',
    connectWithUs: 'Connect With Us',
    joinTelegram: 'Join our Telegram',
    viewOnGitHub: 'View on GitHub',
    joinCommunityForUpdates: 'Join our community for updates, tips, and support',
    allRightsReserved: 'All rights reserved.',
    
    // Dashboard specific
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    dashboardSubtitle: "Here's the status of your documentary rendering projects",
    
    systemLoad: 'System Load',
    allSystemsOperational: 'All Systems Operational',
    systemPerformanceDegraded: 'System Performance Degraded',
    systemIssuesDetected: 'System Issues Detected',
    
    rendersAvailable: 'Renders Available',
    inQueue: 'In Queue',
    completed: 'Completed',
    nextReset: 'Next Reset',
    
    monthlyRenders: 'Monthly Renders',
    renderTypes: 'Render Types',
    recentRenders: 'Recent Renders',
    viewAll: 'View All',
    loadingRenders: 'Loading renders...',
    noRecentRenders: 'No recent renders found',
    
    upgradeToStudioPlan: 'Upgrade to Studio Plan',
    studioPlanDescription: 'Get access to 4K rendering, express queue, and 35 renders per month. Perfect for documentary creators with multiple projects.',
    upgradeNow: 'Upgrade Now',
    
    systemPerformanceNotice: 'System Performance Notice',
    higherThanNormalLoad: "We're experiencing higher than normal load on our render farm. Your renders might take slightly longer than usual. We're working on expanding capacity.",
    
    // My Renders
    allYourProjects: 'All your documentary visualization projects',
    newRender: 'New Render',
    name: 'Name',
    duration: 'Duration',
    resolution: 'Resolution',
    created: 'Created',
    status: 'Status',
    noRenders: 'No renders found. Create your first render to get started!',
    createNewRender: 'Create New Render',
    
    // Upload/New Render
    uploadYourBlenderFile: 'Upload your Blender file for rendering',
    uploadFile: 'Upload File',
    renderSettings: 'Render Settings',
    reviewAndSubmit: 'Review & Submit',
    
    dragAndDropBlend: 'Drag and drop your .blend file',
    orClickToBrowse: 'or click to browse',
    selectFile: 'Select File',
    uploading: 'Uploading...',
    uploadedSuccessfully: 'Uploaded Successfully',
    changeFile: 'Change File',
    continue: 'Continue',
    tipsPackTextures: 'Make sure all textures are packed in your .blend file for the best results.',
    
    projectName: 'Project Name',
    enterProjectName: 'Enter project name',
    animationLength: 'Animation Length (seconds)',
    renderQuality: 'Render Quality',
    queuePriority: 'Queue Priority',
    
    economyQueue: 'Economy Queue',
    standardQueueOption: 'Standard Queue',
    priorityQueue: 'Priority Queue (+$5)',
    expressQueue: 'Express Queue (+$10)',
    
    back: 'Back',
    renderCost: 'Render Cost',
    total: 'Total',
    thisRenderWillUse: 'This render will use 1 of your available render credits.',
    submitRenderJob: 'Submit Render Job',
    
    // Settings
    profileInformation: 'Profile Information',
    currentPlan: 'Current Plan',
    availablePlans: 'Available Plans',
    generalSettings: 'General Settings',
    securitySettings: 'Security Settings',
    
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    
    subscription: 'Subscription',
    preferences: 'Preferences',
    security: 'Security',
    
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    updatePassword: 'Update Password',
    updating: 'Updating...',
    
    language: 'Language',
    emailNotifications: 'Email Notifications',
    renderCompletionNotifications: 'Render completion notifications',
    weeklyUsageReports: 'Weekly usage reports',
    marketingUpdates: 'Marketing updates',
    savePreferences: 'Save Preferences',
    
    proPlan: 'Pro Plan',
    studioPlan: 'Studio Plan',
    month: '/month',
    rendersPerMonth: 'renders per month',
    fourKResolution: '4K resolution',
    rendersmo:'100 Renders/mo',
    priorityQueueAccess: 'Priority queue',
    emailSupport: 'Email support',
    advancedAnalytics: 'Advanced analytics',
    expressQueueAccess: 'Express queue',
    dedicatedSupport: 'Dedicated support',
    teamCollaboration: 'Team collaboration',
    customBranding: 'Custom branding',
    upgradeTo: 'Upgrade to',
    
    // Analytics
    detailedInsights: 'Detailed insights into your rendering activity',
    totalRenders: 'Total Renders',
    avgRenderTime: 'Avg. Render Time',
    rendersThisMonth: 'Renders This Month',
    queueDistribution: 'Queue Distribution',
    estimatedWaitTimes: 'Estimated Wait Times',
    activeRenders: 'Active Renders',
    jobsInQueue: 'Jobs in Queue',
    averageRenderTime: 'Average Render Time (minutes)',
    renderTypesDistribution: 'Render Types Distribution',
    renderQualityVsTime: 'Render Quality vs Time',
    resolutionDistribution: 'Resolution Distribution',
    estimatedCost: 'Estimated Cost',
    estimatedRenderTime: 'Estimated Render Time',
    jobDetails: 'Job Details',
    startRender: 'Start Render',
    minutes: 'minutes',
    
    // Queue Management
    renderQueueManagement: 'Render Queue Management',
    queueManagement: 'Queue Management',
    overviewTab: 'Overview',
    queues: 'Queue Management',
    analyticsTab: 'Analytics',
    settingsTab: 'Settings',
    
    systemPaused: 'The queue processing system is currently paused. No new renders will start until resumed.',
    resumeProcessing: 'Resume Processing',
    pauseProcessing: 'Pause Processing',
    
    queueSummary: 'Queue Summary',
    avgWait: 'Avg. Wait',
    view: 'View',
    
    // File Upload Enhanced
    enhancedFileUpload: 'Enhanced File Upload',
    uploadBlenderFiles: 'Upload your Blender files or assets for rendering',
    supportedFormats: 'Supported formats: .blend, .obj, .fbx, .jpg, .png, .hdr',
    maximumFileSize: 'Maximum file size: 500MB',
    uploadedFiles: 'Uploaded Files',
    clearAll: 'Clear All',
    done: 'Done',
    error: 'Error',
    
    // Common UI elements
    save: 'Save',
    cancel: 'Cancel',
    loading: 'Loading...',
    success: 'Success',
    warning: 'Warning',
    close: 'Close',
    refresh: 'Refresh',
    exportLogs: 'Export Logs',
    quickFixes: 'Quick Fixes',
    refreshPage: 'Refresh Page',
    retestConnection: 'Retest Connection',
    clearCacheAndReload: 'Clear Cache & Reload',
    testBackendDirectly: 'Test Backend Directly',
    testing: 'Testing...',
    
    // Status messages
    complete: 'Complete',
    rendering: 'Rendering',
    queued: 'Queued',
    failed: 'Failed',
    pending: 'Pending',
    verifying: 'Verifying',
    expired: 'Expired',
    
    // Time and dates
    seconds: 'seconds',
    min: 'min',
    hours: 'hours',
    days: 'days',
    ago: 'ago',
    remaining: 'remaining',
    
    // Plans and features
    standardPlan: 'Standard',
    highQuality: 'High',
    ultraQuality: 'Ultra',
    
    // Payment
    upgradeSubscription: 'Upgrade Subscription',
    payWithUSDT: 'Pay with USDT',
    paymentMethod: 'Payment Method',
    trc20Network: 'USDT (TRC-20)',
    choosePaymentMethod: 'Choose Payment Method',
    creditCard: 'Credit Card',
    comingSoon: 'Coming Soon',
    creditCardPayments: 'Credit card payments will be available soon!',
    regionalQR: 'Regional QR',
    payInLocalCurrency: 'Pay in your local currency',
    chooseYourCountry: 'Choose your country to see available payment methods',
    selectedPlan: 'Selected plan',
    payIn: 'Pay in',
    viewPaymentMethods: 'View payment methods',
    backToPaymentMethods: 'Back to Payment Methods',
    paymentInstructions: 'Payment Instructions',
    completeYourPayment: 'Complete Your Payment',
    amountToPay: 'Amount to Pay',
    paymentAccount: 'Payment Account',
    scanWith: 'Scan with',
    quickPayment: 'Quick Payment',
    scanQRCode: 'Scan this QR code with your wallet:',
    manualCopy: 'Or manually copy the amount and address above',
    enterTransactionHash: 'Enter transaction hash (after sending):',
    pasteTransactionHash: 'Paste your transaction hash here...',
    transactionHashHelp: "You'll get this from your wallet after sending the payment",
    doubleCheck: 'Double-check before sending:',
    sendExactly: 'Send EXACTLY',
    useTronNetwork: 'Use Tron network (TRC-20) only',
    sendFromPersonalWallet: 'Send from personal wallet (not exchange)',
    verifyWalletAddress: 'Verify wallet address is correct',
    saveTransactionHash: 'Save your transaction hash',
    verifyPayment: 'Verify Payment',
    paymentSubmitted: 'Payment Submitted!',
    thankYouForPayment: 'Thank you for your payment! Please send us your payment screenshot via Telegram for manual verification.',
    paymentDetails: 'Payment Details:',
    plan: 'Plan',
    amount: 'Amount',
    method: 'Method',
    time: 'Time',
    manualVerificationRequired: 'Manual Verification Required',
    renderCreditsAvailable: 'Your render credits will be available within 10 minutes after we verify your payment screenshot.',
    sendPaymentScreenshot: 'Send Payment Screenshot via Telegram',
    pleaseIncludeScreenshot: 'Please include your payment screenshot and mention:',
    yourPlan: 'Your plan:',
    paymentAmount: 'Payment amount:',
    paymentMethod: 'Payment method:',
    backToDashboard: 'Back to Dashboard',
    manualVerificationProcess: 'Manual Verification Process',
    paymentVerificationTime: 'Your subscription will be activated immediately after we confirm your payment screenshot via Telegram.',
    
    // Actions
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    download: 'Download',
    retry: 'Retry',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    
    // Notifications
    profileUpdatedSuccessfully: 'Profile updated successfully!',
    passwordUpdatedSuccessfully: 'Password updated successfully!',
    subscriptionUpgradedSuccessfully: 'Subscription upgraded successfully!',
    fileUploadedSuccessfully: 'File uploaded successfully!',
    renderJobCreatedSuccessfully: 'Render job created successfully!',
    
    // Language switcher
    switchToEnglish: 'Switch to English',
    switchToChinese: 'Switch to Chinese',
    currentLanguage: 'Current',
    
    // Theme
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    
    // User info
    rendersRemaining: 'renders remaining this month',
    
    // Admin & Worker specific
    workerStatus: 'Worker Status',
    paymentVerification: 'Payment Verification',
    workerDashboard: 'Worker Dashboard',
    systemStatus: 'System Status',
    operational: 'Operational',
    activeWorkers: 'Active Workers',
    totalWorkers: 'Total Workers',
    maxConcurrentRenders: 'Max Concurrent Renders',
    completedRenders: 'Completed Renders',
    failedRenders: 'Failed Renders',
    uptime: 'Uptime',
    memoryUsage: 'Memory Usage',
    freeMemory: 'Free Memory',
    cpuCores: 'CPU Cores',
    currentQueueStatus: 'Current Queue Status',
    expressQueue: 'Express Queue',
    priorityQueue: 'Priority Queue',
    standardQueue: 'Standard Queue',
    economyQueue: 'Economy Queue',
    adminDashboard: 'Admin Dashboard',
welcomeBack: 'Welcome back',
connectionDiagnostics: 'Connection Diagnostics',
regionalQRPayment: 'Regional QR Payment',
createRenderJob: 'Create Render Job',
analyticsDashboard: 'Analytics Dashboard',
paymentSuccessful: 'Payment Successful!',
queueStatus: 'Queue Status',
realTimeMonitoring: 'Real-time monitoring of render workers',
// Admin
adminDashboard: 'Admin Dashboard',
welcomeBack: 'Welcome back',
paymentVerificationQueue: 'Payment Verification Queue',
userManagement: 'User Management',
allCaughtUp: 'All Caught Up!',
noPendingPayments: 'No pending payments require verification at this time',
paymentDetails: 'Payment Details',
adminActions: 'Admin Actions',
verificationNotes: 'Verification Notes',
approve: 'Approve',
reject: 'Reject',
contactUserViaTelegram: 'Contact User via Telegram',

// Connection
testingConnection: 'Testing connection...',
connectionIsWorkingWell: 'Connection is working well',
recommendedSolutions: 'Recommended Solutions',
quickFixes: 'Quick Fixes',
refreshPage: 'Refresh Page',
clearCacheAndReload: 'Clear Cache & Reload',
testBackendDirectly: 'Test Backend Directly',

// Crypto Payment
chooseCryptocurrency: 'Choose Cryptocurrency',
selectPreferredCrypto: 'Select your preferred cryptocurrency for payment',
popularAndRecommended: 'Popular & Recommended',
otherOptions: 'Other Options',
importantRequirements: 'Important Requirements',
sendExactly: 'Send exactly',
paymentExpired: 'Payment Expired',
startOver: 'Start Over',
creatingPaymentRequest: 'Creating payment request...',
sendExactlyThisAmount: 'Send exactly this amount:',
toThisWalletAddress: 'To this wallet address:',
enterTransactionHash: 'Enter transaction hash (after sending):',
verifyPayment: 'Verify Payment',
paymentConfirmed: 'Payment Confirmed!',
verifyingPayment: 'Verifying Payment...',
paymentFailed: 'Payment Failed',

// Worker & Queue
realTimeMonitoring: 'Real-time monitoring of render workers',
loadingQueueStatus: 'Loading queue status...',
unableToLoadQueueStatus: 'Unable to load queue status',
processingPaused: 'Processing paused',
processingActive: 'Processing active',
queueTips: 'Queue Tips',
expressQueueTip: 'Express queue processes jobs fastest but costs more',
economyQueueTip: 'Economy queue is free but may have longer wait times',
cpuAndMemory: 'CPU & Memory',
performanceOverTime: 'Performance Over Time',
activeJobs: 'Active Jobs',
renderStudio: 'Render Studio',
professionalBlenderRendering: 'Professional Blender rendering in the cloud. Upload your .blend files and get stunning results.',
lightningFast: 'Lightning Fast',
powerfulGpuClusters: 'Powerful GPU clusters render your projects up to 10x faster than local machines.',
cloudBased: 'Cloud-Based',
noExpensiveHardware: 'No expensive hardware needed. Access professional rendering power from anywhere.',
secureReliable: 'Secure & Reliable',
filesEncryptedSecure: 'Your files are encrypted and stored securely. 99.9% uptime guaranteed.',
free: 'Free',
forever: 'forever',
threeRendersPerMonth: '3 renders/month',
startFree: 'Start Free',
pro: 'Pro',
twintyRendersPerMonth: '20 renders/month',
thirtyfiveRendersPerMonth:'35 renders/month',
liveChatSupport: 'Live chat support',
goPro: 'Go Pro',
studio: 'Studio',
getStudio: 'Get Studio',
documentaryCreator: 'Documentary Creator',
contentCreator: 'Content Creator',
testimonial1: 'Render Studio transformed my workflow. What used to take days now takes hours!',
testimonial2: 'The quality is incredible and the speed is unmatched. Perfect for client work.',
testimonial3: 'Finally, professional rendering without the massive hardware investment.',
heroDescription: 'Transform your Blender projects into stunning animations with our powerful cloud rendering platform. No expensive hardware. No waiting. Just results.',
ancientRomeScene: 'Ancient Rome Scene',
dnaVisualization: 'DNA Visualization',
rendering67Percent: 'Rendering 67%',
solarSystemTour: 'Solar System Tour',
dragDropBlendFile: 'Simply drag and drop your .blend file. We support all Blender versions and project types.',
chooseResolutionQuality: 'Choose your resolution, quality, and priority. Our smart system handles the rest.',
getNotifiedWhenComplete: 'Get notified when complete and download your high-quality render in minutes, not hours.',
simpleTransparentPricing: 'Simple, Transparent Pricing',
startFreeUpgrade: 'Start free, upgrade when you need more power',
mostPopular: 'Most Popular',
lovedByCreators: 'Loved by Creators',
joinThousandsSatisfied: 'Join thousands of satisfied users',
readyToAccelerate: 'Ready to Accelerate Your 3D Workflow?',
joinThousandsCreators: 'Join thousands of creators who\'ve already made the switch to cloud rendering.',
startYourFreeTrial: 'Start Your Free Trial',
joinTenThousandCreators: 'Join 10,000+ creators',
professionalRenderingCloud: 'Professional 3D rendering in the cloud',
transformCreativeVision: 'Transform your creative vision into reality with our powerful cloud rendering platform.',
joinCommunityForUpdates: 'Join our community for updates, tips, and support',
allRightsReserved: 'All rights reserved.',
name:'Name',
resolution:'Resolution',
duration: 'Duration',
created: 'Created',
time: 'Time',
status: 'Status & Actions',
logs:'Logs',
totalrenders: 'Total Renders',
completed: 'Completed',
inprogress: 'In Progress',
failed: 'Failed',
quality:'quality',
preview:'Preview',
renderingframe:'Rendering frame',
videoerror:'Your browser does not support video preview.',
waiting:'Waiting in',
queue:'queue...',
renderfailed:'Render Failed',
chooseCryptocurrency: 'Choose Cryptocurrency',
  selectPreferredCrypto: 'Select your preferred cryptocurrency for payment',
  cancel: 'Cancel',
  payWith: 'Pay with',
  reviewPaymentDetails: 'Review payment details',
  plan: 'Plan',
  usdAmount: 'USD Amount',
  cryptoAmount: 'Crypto Amount',
  paymentDetails: 'Payment Details',
  network: 'Network',
  fees: 'Fees',
  confirmation: 'Confirmation',
  timeLimit: 'Time Limit',
  minutes: 'minutes',
  important: 'Important',
  sendExactly: 'Send exactly',
  useNetworkOnly: 'Use network only',
  sendFromPersonalWallet: 'Send from personal wallet',
  saveTransactionHash: 'Save your transaction hash',
  back: 'Back',
  continue: 'Continue',
  sendPayment: 'Send Payment',
  payment: 'Payment',
  paymentExpired: 'Payment Expired',
  paymentExpiredDesc: 'This payment request has expired. Please start over to create a new payment.',
  startOver: 'Start Over',
  creatingPaymentRequest: 'Creating payment request...',
  sendExactlyThisAmount: 'Send exactly this amount:',
  mustBeExactAmount: 'Must be exact amount - no more, no less',
  toThisWalletAddress: 'To this wallet address:',
  networkOnly: 'network only',
  quickPayment: 'Quick Payment',
  scanQRCode: 'Scan this QR code with your wallet:',
  orManualCopy: 'Or manually copy the amount and address above',
  enterTransactionHash: 'Enter transaction hash (after sending):',
  pasteTransactionHash: 'Paste your transaction hash here...',
  transactionHashHelp: "You'll get this from your wallet after sending the payment",
  doubleCheckBeforeSending: 'Double-check before sending:',
  usePersonalWallet: 'Send from personal wallet (not exchange)',
  verifyWalletAddress: 'Verify wallet address is correct',
  verifying: 'Verifying...',
  verifyPayment: 'Verify Payment',
  verifyingPayment: 'Verifying Payment',
  transactionSubmitted: 'Your transaction has been submitted for manual verification. This usually takes 5-10 minutes.',
  viewTransaction: 'View Transaction',
  paymentConfirmed: 'Payment Confirmed!',
  subscriptionActivated: 'Your subscription has been activated. Welcome aboard!',
  quickValidation: 'Quick Validation',
  getVerifiedUnder10Min: 'Get verified in under 10 minutes',
  thankYouForPayment: 'Thank you for your payment! For faster processing, you can send a screenshot of your transaction to our Telegram.',
  usuallyVerifiedWithin: 'Usually verified within 10 minutes',
  sendScreenshotToTelegram: 'Send Screenshot to Telegram',
  orContinueToDashboard: 'Or continue to dashboard (verification will happen automatically)',
  continueToDashboard: 'Continue to Dashboard',
  paymentFailed: 'Payment Failed',
  paymentFailedDesc: "We couldn't verify your payment. Please check your transaction hash and try again.",
  tryAgain: 'Try Again',
  settings: 'Settings',
  profile: 'Profile',
  subscription: 'Subscription',
  preferences: 'Preferences',
  security: 'Security',
  profileInformation: 'Profile Information',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  youtubeChannel: 'YouTube Channel',
  optional: 'Optional',
  saveChanges: 'Save Changes',
  saving: 'Saving...',
  currentPlan: 'Current Plan',
  rendersRemainingThisMonth: 'renders remaining this month',
  resetsOn: 'Resets on',
  active: 'Active',
  availablePlans: 'Available Plans',
  mostPopular: 'MOST POPULAR',
  current: 'CURRENT',
  month: '/month',
  perRender: 'per render',
  currentPlanButton: 'Current Plan',
  upgradeTo: 'Upgrade to',
  multiplePaymentOptions: 'Multiple Payment Options',
  paymentOptionsDesc: 'We accept credit card and regional QR payments for fast, secure transactions. Choose the payment method that works best for you.',
  language: 'Language',
  currentLanguage: 'Current',
  emailNotifications: 'Email Notifications',
  renderCompletionNotifications: 'Render completion notifications',
  weeklyUsageReports: 'Weekly usage reports',
  marketingUpdates: 'Marketing updates',
  savePreferences: 'Save Preferences',
  securitySettings: 'Security Settings',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  updatePassword: 'Update Password',
  updating: 'Updating...',
  profileUpdatedSuccessfully: 'Profile updated successfully!',
  passwordUpdatedSuccessfully: 'Password updated successfully!',
  subscriptionUpgradedSuccessfully: 'Subscription upgraded successfully!',
  newPasswordsDoNotMatch: 'New passwords do not match',
  passwordMustBe6Chars: 'Password must be at least 6 characters',
  channelUrlPlaceholder: 'Channel URL or handle',
  plan: 'Plan',
  makesure:'Make sure all textures are packed in your .blend file',
filesize:'File size should be less than 100MB',
supported:'Only .blend files are supported',
seconds: 'seconds',
minutes:'minutes',
rendercost:'Base Render Cost',
free:'Free',
freerender:'Free Render',
availablerenders:'This render will use one of your available free render credits.',
creating:'Creating...',
upgradeTo: 'Upgrade to',
  payWithUSDT: 'Pay with USDT cryptocurrency',
  plan: 'Plan',
  price: 'Price',
  paymentMethod: 'Payment Method',
  usdtTrc20: 'USDT (TRC-20)',
  sendPaymentUsing: 'Send payment using USDT on Tron network (TRC-20)',
  paymentCompleted30Min: 'Payment must be completed within 30 minutes',
  needTronWallet: "You'll need a Tron wallet or exchange account",
  transactionFeesLow: 'Transaction fees are typically very low (1-2 USDT)',
  importantRequirements: 'Important Requirements:',
  sendExactly: 'Send exactly',
  useTronNetworkOnly: 'Use Tron network (TRC-20) only',
  sendFromPersonalWallet: 'Send from personal wallet (not from exchange)',
  keepTransactionHash: 'Keep your transaction hash for verification',
  continueWithUSDT: 'Continue with USDT',
  cancel: 'Cancel',
  sendUSDTPayment: 'Send USDT Payment',
  paymentExpired: 'Payment Expired',
  paymentExpiredDesc: 'This payment request has expired. Please start over to create a new payment.',
  startOver: 'Start Over',
  creatingPaymentRequest: 'Creating payment request...',
  sendExactlyThisAmount: 'Send exactly this amount:',
  mustBeExactAmount: 'Must be exact amount - no more, no less',
  toThisWalletAddress: 'To this wallet address:',
  tronNetworkOnly: 'Tron Network (TRC-20) only',
  quickPayment: 'Quick Payment',
  scanQRWithWallet: 'Scan this QR code with your Tron wallet:',
  orManuallyCopy: 'Or manually copy the amount and address above',
  enterTransactionHash: 'Enter transaction hash (after sending):',
  pasteTransactionHash: 'Paste your transaction hash here...',
  transactionHashFromWallet: "You'll get this from your wallet after sending the payment",
  doubleCheckBeforeSending: 'Double-check before sending:',
  verifyWalletAddress: 'Verify wallet address is correct',
  saveTransactionHash: 'Save your transaction hash',
  verifying: 'Verifying...',
  verifyPayment: 'Verify Payment',
  paymentConfirmed: 'Payment Confirmed!',
  verifyingPayment: 'Verifying Payment...',
  paymentFailed: 'Payment Failed',
  paymentStatus: 'Payment Status',
  congratsSubscriptionActive: 'subscription is now active. You can start using your new features immediately.',
  verifyingTransaction: "We're verifying your transaction on the Tron blockchain. This usually takes 1-5 minutes. Please wait...",
  couldntVerifyPayment: "We couldn't verify your payment. Please check your transaction hash and try again, or contact support if the issue persists.",
  checkingPaymentStatus: 'Checking payment status...',
  transactionHash: 'Transaction Hash:',
  view: 'View',
  whatsNext: "What's Next?",
  subscriptionImmediatelyActive: 'Your subscription is immediately active',
  newRenderQuota: 'New render quota has been applied',
  premiumFeaturesAvailable: 'Premium features are now available',
  higherQualityUnlocked: 'Higher quality renders unlocked',
  continueToDashboard: 'Continue to Dashboard',
  commonIssues: 'Common Issues:',
  incorrectTransactionHash: 'Incorrect transaction hash',
  wrongAmountSent: 'Wrong amount sent',
  wrongNetwork: 'Wrong network (use TRC-20 only)',
  transactionStillPending: 'Transaction still pending',
  tryAgain: 'Try Again',
  verificationInProgress: 'Verification in progress...',
  checkingBlockchain: "We're checking the Tron blockchain for your transaction. This process is automatic and usually completes within 5 minutes.",
  closeVerificationContinues: 'Close (verification will continue in background)',
  upgradeYourSubscription: 'Upgrade Your Subscription',
  choosePerfectPlan: 'Choose the perfect plan for your rendering needs. All plans include unlimited project uploads, cloud storage, and 24/7 technical support.',
  currentPlan: 'Current Plan',
  resetOn: 'Reset on',
  mostPopular: 'MOST POPULAR',
  current: 'CURRENT',
  month: '/month',
  perRender: 'per render',
  currentPlanButton: 'Current Plan',
  upgradeTo: 'Upgrade to',
  planComparison: 'Plan Comparison',
  feature: 'Feature',
  basic: 'Basic',
  pro: 'Pro',
  studio: 'Studio',
  monthlyRenders: 'Monthly Renders',
  maxResolution: 'Max Resolution',
  queuePriority: 'Queue Priority',
  apiAccess: 'API Access',
  frequentlyAskedQuestions: 'Frequently Asked Questions',
  canChangePlans: 'Can I change plans anytime?',
  canChangePlansAnswer: 'Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately.',
  whatHappensUnused: 'What happens to unused renders?',
  whatHappensUnusedAnswer: "Unused renders don't roll over to the next month. Your render quota resets monthly.",
  howRefundsWork: 'How do refunds work?',
  howRefundsWorkAnswer: 'We offer a 7-day money-back guarantee for all subscription plans, no questions asked.',
  maybeLater: 'Maybe Later',
  youAlreadyHaveThisPlan: 'You already have this plan',
  subscriptionUpgradedSuccessfully: 'Subscription upgraded successfully!',
  renderQueueManagement: 'Render Queue Management',
  systemLoad: 'System Load',
  resumeProcessing: 'Resume Processing',
  pauseProcessing: 'Pause Processing',
  systemPaused: 'The queue processing system is currently paused. No new renders will start until resumed.',
  queueDistribution: 'Queue Distribution',
  estimatedWaitTimes: 'Estimated Wait Times',
  min: 'min',
  minutes: 'minutes',
  jobsInQueue: 'Jobs in Queue',
  activeRenders: 'Active Renders',
  queueSummary: 'Queue Summary',
  avgWait: 'Avg Wait',
  loadingQueueData: 'Loading queue data...',
  queueDataError: 'Queue Data Error',
  retry: 'Retry',
  noActiveRenders: 'No active renders at the moment',
  jobName: 'Job Name',
  user: 'User',
  started: 'Started',
  progress: 'Progress',
  estCompletion: 'Est. Completion',
  backend: 'Backend',
  totalJobs: 'Total Jobs',
  renderAnalytics: 'Render Analytics',
  performanceMetrics: 'Performance metrics and usage statistics',
  averageRenderTime: 'Average Render Time (minutes)',
  renderTypes: 'Render Types',
  minutes: 'minutes',
  count: 'Count',
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  historical: 'Historical',
  scientific: 'Scientific',
  dataViz: 'Data Viz',
  nature: 'Nature',
  space: 'Space',
  payWithPayPal: 'Pay with PayPal',
  paymentRequiresVerification: 'Payment requires manual verification (usually 5-10 minutes)',
  processingPayment: 'Processing payment...',
  chooseDifferentPaymentMethod: 'Choose Different Payment Method',
  securePaymentPoweredBy: 'Secure payment powered by PayPal. Payment will be verified by admin within 10 minutes.',
  paymentSubmittedVerification: 'Payment submitted for verification! Transaction:',
  paypalPaymentFailed: 'PayPal payment failed:',
  paymentWasCancelled: 'Payment was cancelled',
  month: '/month',
   createRenderJob: 'Create Render Job',
  uploadBlendFile: 'Upload Blend File',
  uploadingFile: 'Uploading file...',
  fileUploaded: 'File uploaded',
  configureRenderJob: 'Configure Render Job',
  projectName: 'Project Name',
  durationSeconds: 'Duration (seconds)',
  resolution: 'Resolution',
  quality: 'Quality',
  priority: 'Priority',
  creatingRenderJob: 'Creating render job...',
  fileUploadedSuccessfully: 'Blend file uploaded successfully!',
  uploadFailed: 'Upload failed',
  pleaseUploadFileFirst: 'Please upload a .blend file first!',
  renderJobCreatedSuccessfully: 'Render job created successfully!',
  createRenderJobFailed: 'Failed to create render job',
  rendersPerMonth8: '8 renders per month',
  rendersPerMonth20: '20 renders per month',
  rendersPerMonth35: '35 renders per month',
  resolution1080p: '1080p resolution',
  resolution4K: '4K resolution',
  resolution4KPlus: '4K+ resolution',
  standardQueue: 'Standard queue',
  priorityQueue: 'Priority queue',
  expressQueueNextInLine: 'Express queue (next in line)',
  emailSupport: 'Email support',
  prioritySupport: 'Priority support',
  dedicatedSupport: 'Dedicated support',
  startYourJourneyBasic: 'Start Your Journey with Basic Plan',
  getStartedWith8Renders: 'Get started with',
  rendersPerMonthStrong: '8 renders per month',
  forJust: 'for just',
  upgradeToProStudio: 'Upgrade to Pro (20 renders) or Studio (35 renders) for even better value!',
  hdResolution: 'HD Resolution',
  standardQueue: 'Standard Queue',
  emailSupport: 'Email Support',
  choosePlan: 'Choose Plan',
  allSystemsOperational: 'All Systems Operational',
  systemPerformanceDegraded: 'System Performance Degraded',
  systemIssuesDetected: 'System Issues Detected',
  dashboard: 'Dashboard',
  myRenders: 'My Renders',
  newRender: 'New Render',
  settings: 'Settings',
  workerStatus: 'Worker Status',
  paymentVerification: 'Payment Verification',
  queueOrderTip:'Jobs are processed in priority order: Express → Priority → Standard → Economy',
  processingTimeTip:'Processing times depend on project complexity and current system load'
  },
  zh: {
    // Navigation & UI
    dashboard: '仪表板',
    myRenders: '我的渲染',
    newRender: '新建渲染',
    settings: '设置',
    signOut: '退出登录',
    analytics: '分析',
    upload: '上传',
    profile: '个人资料',
    
    // Authentication
    signIn: '登录',
    signUp: '注册',
    createAccount: '创建账户',
    email: '邮箱地址',
    password: '密码',
    firstName: '名字',
    lastName: '姓氏',
    youtubeChannel: 'YouTube频道',
    optional: '可选',
    min6chars: '最少6个字符',
    
    // Common phrases
    toRenderStudio: '到渲染工作室',
    dontHaveAccount: '还没有账户？',
    alreadyHaveAccount: '已有账户？',
    backToHome: '返回首页',
    signingIn: '登录中...',
    creatingAccount: '创建账户中...',
    confirmLogout: '确定要退出登录吗？',
    freePlan: '免费计划',
    
    // Connection and errors
    testConnection: '测试连接',
    runConnectionTest: '运行连接诊断',
    connectionDiagnostics: '连接诊断',
    connectionIsWorkingWell: '连接工作正常',
    someConnectionIssuesDetected: '检测到一些连接问题',
    multipleConnectionProblems: '多个连接问题',
    connectionTestFailed: '连接测试失败',
    testingConnection: '测试连接中...',
    connectionStatusUnknown: '连接状态未知',
    
    // Subscription benefits
    byCreatingAccount: '创建账户后您将获得',
    '3FreeRenders': '每月3次免费渲染',
    '1080pResolution': '1080p分辨率',
    standardQueue: '标准队列优先级',
    accessToUpgrade: '升级计划访问权限',

    // Landing Page
    welcome: '欢迎来到渲染工作室',
    professional: '专业的',
    rendering: '3D渲染',
    inTheCloud: '云端服务',
    heroSubtitleLanding: '使用我们强大的云渲染平台，将您的Blender项目转换为令人惊叹的动画。无需昂贵的硬件，无需等待，只有结果。',
    startRenderingFree: '免费开始渲染',
    watchDemo: '观看演示',
    noCreditCardRequired: '无需信用卡',
    includedFreeRenders: '包含3次免费渲染',
    
    whyChooseRenderStudio: '为什么选择渲染工作室？',
    professionalToolsDescription: '专业工具，云端力量，简化工作流程',
    
    // Features
    features: '功能特性',
    animationRendering: '3D动画渲染',
    animationRenderingDescription: '专业的云端Blender渲染。上传您的.blend文件，获得令人惊叹的结果。',
    pricing: '价格方案',
    contact: '联系我们',
    
    // Footer
    quickLinks: '快速链接',
    documentation: '文档',
    support: '支持',
    connectWithUs: '联系我们',
    joinTelegram: '加入我们的Telegram',
    viewOnGitHub: '在GitHub上查看',
    joinCommunityForUpdates: '加入我们的社区获取更新、技巧和支持',
    allRightsReserved: '保留所有权利。',
    
    // Dashboard specific
    goodMorning: '早上好',
    goodAfternoon: '下午好',
    goodEvening: '晚上好',
    dashboardSubtitle: '这是您的纪录片渲染项目状态',
    
    systemLoad: '系统负载',
    allSystemsOperational: '所有系统正常运行',
    systemPerformanceDegraded: '系统性能下降',
    systemIssuesDetected: '检测到系统问题',
    
    rendersAvailable: '可用渲染',
    inQueue: '队列中',
    completed: '已完成',
    nextReset: '下次重置',
    
    monthlyRenders: '月度渲染',
    renderTypes: '渲染类型',
    recentRenders: '最近渲染',
    viewAll: '查看全部',
    loadingRenders: '加载渲染中...',
    noRecentRenders: '未找到最近的渲染',
    
    upgradeToStudioPlan: '升级到工作室计划',
    studioPlanDescription: '获得4K渲染、快速队列和每月100次渲染的访问权限。非常适合有多个项目的纪录片创作者。',
    upgradeNow: '立即升级',
    
    systemPerformanceNotice: '系统性能通知',
    higherThanNormalLoad: '我们的渲染农场正在经历高于正常的负载。您的渲染可能需要比平时稍长的时间。我们正在努力扩展容量。',
    
    // My Renders
    allYourProjects: '您所有的纪录片可视化项目',
    newRender: '新建渲染',
    name: '名称',
    duration: '时长',
    resolution: '分辨率',
    created: '创建时间',
    status: '状态',
    noRenders: '未找到渲染。创建您的第一个渲染以开始使用！',
    createNewRender: '创建新渲染',
    
    // Upload/New Render
    uploadYourBlenderFile: '上传您的Blender文件进行渲染',
    uploadFile: '上传文件',
    renderSettings: '渲染设置',
    reviewAndSubmit: '审查并提交',
    
    dragAndDropBlend: '拖放您的.blend文件',
    orClickToBrowse: '或点击浏览',
    selectFile: '选择文件',
    uploading: '上传中...',
    uploadedSuccessfully: '上传成功',
    changeFile: '更改文件',
    continue: '继续',
    tipsPackTextures: '确保您的.blend文件中打包了所有纹理以获得最佳效果。',
    
    projectName: '项目名称',
    enterProjectName: '输入项目名称',
    animationLength: '动画长度（秒）',
    renderQuality: '渲染质量',
    queuePriority: '队列优先级',
    
    economyQueue: '经济队列',
    standardQueueOption: '标准队列',
    priorityQueue: '优先队列（+$5）',
    expressQueue: '快速队列（+$10）',
    
    back: '返回',
    renderCost: '渲染费用',
    total: '总计',
    thisRenderWillUse: '此渲染将使用您可用渲染点数中的1个。',
    submitRenderJob: '提交渲染任务',
    
    // Settings
    profileInformation: '个人资料信息',
    currentPlan: '当前计划',
    availablePlans: '可用计划',
    generalSettings: '常规设置',
    securitySettings: '安全设置',
    
    saveChanges: '保存更改',
    saving: '保存中...',
    
    subscription: '订阅',
    preferences: '偏好设置',
    security: '安全',
    
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    updatePassword: '更新密码',
    updating: '更新中...',
    
    language: '语言',
    emailNotifications: '邮件通知',
    renderCompletionNotifications: '渲染完成通知',
    weeklyUsageReports: '每周使用报告',
    marketingUpdates: '营销更新',
    savePreferences: '保存偏好设置',
    
    proPlan: '专业计划',
    studioPlan: '工作室计划',
    month: '/月',
    rendersPerMonth: '每月渲染次数',
    fourKResolution: '4K分辨率',
    rendersmo:'100 渲染/月',
    priorityQueueAccess: '优先队列',
    emailSupport: '邮件支持',
    advancedAnalytics: '高级分析',
    expressQueueAccess: '快速队列',
    dedicatedSupport: '专属支持',
    teamCollaboration: '团队协作',
    customBranding: '自定义品牌',
    upgradeTo: '升级到',
    
    // Analytics
    detailedInsights: '您的渲染活动的详细洞察',
    totalRenders: '总渲染数',
    avgRenderTime: '平均渲染时间',
    rendersThisMonth: '本月渲染',
    queueDistribution: '队列分布',
    estimatedWaitTimes: '预估等待时间',
    activeRenders: '活跃渲染',
    jobsInQueue: '队列中的任务',
    averageRenderTime: '平均渲染时间（分钟）',
    renderTypesDistribution: '渲染类型分布',
    renderQualityVsTime: '渲染质量与时间',
    resolutionDistribution: '分辨率分布',
    estimatedCost: '预估费用',
    estimatedRenderTime: '预估渲染时间',
    jobDetails: '任务详情',
    startRender: '开始渲染',
    minutes: '分钟',
    
    // Queue Management
    renderQueueManagement: '渲染队列管理',
    queueManagement: '队列管理',
    overviewTab: '概览',
    queues: '队列管理',
    analyticsTab: '分析',
    settingsTab: '设置',
    
    systemPaused: '队列处理系统目前已暂停。在恢复之前，不会启动新的渲染。',
    resumeProcessing: '恢复处理',
    pauseProcessing: '暂停处理',
    
    queueSummary: '队列摘要',
    avgWait: '平均等待',
    view: '查看',
    
    // File Upload Enhanced
    enhancedFileUpload: '增强文件上传',
    uploadBlenderFiles: '上传您的Blender文件或资源进行渲染',
    supportedFormats: '支持的格式：.blend, .obj, .fbx, .jpg, .png, .hdr',
    maximumFileSize: '最大文件大小：500MB',
    uploadedFiles: '已上传文件',
    clearAll: '清除全部',
    done: '完成',
    error: '错误',
    
    // Common UI elements
    save: '保存',
    cancel: '取消',
    loading: '加载中...',
    success: '成功',
    warning: '警告',
    close: '关闭',
    refresh: '刷新',
    exportLogs: '导出日志',
    quickFixes: '快速修复',
    refreshPage: '刷新页面',
    retestConnection: '重新测试连接',
    clearCacheAndReload: '清除缓存并重新加载',
    testBackendDirectly: '直接测试后端',
    testing: '测试中...',
    
    // Status messages
    complete: '完成',
    rendering: '渲染中',
    queued: '队列中',
    failed: '失败',
    pending: '等待中',
    verifying: '验证中',
    expired: '已过期',
    
    // Time and dates
    seconds: '秒',
    min: '分钟',
    hours: '小时',
    days: '天',
    ago: '前',
    remaining: '剩余',
    
    // Plans and features
    standardPlan: '标准',
    highQuality: '高质量',
    ultraQuality: '超高质量',
    
    // Payment
    upgradeSubscription: '升级订阅',
    payWithUSDT: '使用USDT支付',
    paymentMethod: '支付方式',
    trc20Network: 'USDT（TRC-20）',
    choosePaymentMethod: '选择支付方式',
    creditCard: '信用卡',
    comingSoon: '即将推出',
    creditCardPayments: '信用卡支付即将推出！',
    regionalQR: '地区二维码',
    payInLocalCurrency: '使用本地货币支付',
    chooseYourCountry: '选择您的国家查看可用的支付方式',
    selectedPlan: '已选计划',
    payIn: '在以下地区支付',
    viewPaymentMethods: '查看支付方式',
    backToPaymentMethods: '返回支付方式',
    paymentInstructions: '支付说明',
    completeYourPayment: '完成您的支付',
    amountToPay: '支付金额',
    paymentAccount: '支付账户',
    scanWith: '使用以下方式扫描',
    quickPayment: '快速支付',
    scanQRCode: '使用您的钱包扫描此二维码：',
    manualCopy: '或手动复制上方的金额和地址',
    enterTransactionHash: '输入交易哈希（发送后）：',
    pasteTransactionHash: '在此粘贴您的交易哈希...',
    transactionHashHelp: '发送支付后您将从钱包获得此信息',
    doubleCheck: '发送前请仔细检查：',
    sendExactly: '准确发送',
    useTronNetwork: '仅使用Tron网络（TRC-20）',
    sendFromPersonalWallet: '从个人钱包发送（非交易所）',
    verifyWalletAddress: '验证钱包地址正确',
    saveTransactionHash: '保存您的交易哈希',
    verifyPayment: '验证支付',
    paymentSubmitted: '支付已提交！',
    thankYouForPayment: '感谢您的支付！请通过Telegram向我们发送您的支付截图进行人工验证。',
    paymentDetails: '支付详情：',
    plan: '计划',
    amount: '金额',
    method: '方式',
    time: '时间',
    manualVerificationRequired: '需要人工验证',
    renderCreditsAvailable: '在我们验证您的支付截图后10分钟内，您的渲染点数将可用。',
    sendPaymentScreenshot: '通过Telegram发送支付截图',
    pleaseIncludeScreenshot: '请包含您的支付截图并提及：',
    yourPlan: '您的计划：',
    paymentAmount: '支付金额：',
    paymentMethod: '支付方式：',
    backToDashboard: '返回仪表板',
    manualVerificationProcess: '人工验证流程',
    paymentVerificationTime: '在我们通过Telegram确认您的支付截图后，您的订阅将立即激活。',
    
    // Actions
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    download: '下载',
    retry: '重试',
    moveUp: '上移',
    moveDown: '下移',
    
    // Notifications
    profileUpdatedSuccessfully: '个人资料更新成功！',
    passwordUpdatedSuccessfully: '密码更新成功！',
    subscriptionUpgradedSuccessfully: '订阅升级成功！',
    fileUploadedSuccessfully: '文件上传成功！',
    renderJobCreatedSuccessfully: '渲染任务创建成功！',
    
    // Language switcher
    switchToEnglish: '切换到英文',
    switchToChinese: '切换到中文',
    currentLanguage: '当前',
    
    // Theme
    lightMode: '浅色模式',
    darkMode: '深色模式',
    
    // User info
    rendersRemaining: '本月剩余渲染次数',
    
    // Admin & Worker specific
    workerStatus: '工作节点状态',
    paymentVerification: '支付验证',
    workerDashboard: '工作节点仪表板',
    systemStatus: '系统状态',
    operational: '运行中',
    activeWorkers: '活跃工作节点',
    totalWorkers: '总工作节点',
    maxConcurrentRenders: '最大并发渲染',
    completedRenders: '已完成渲染',
    failedRenders: '失败渲染',
    uptime: '运行时间',
    memoryUsage: '内存使用',
    freeMemory: '可用内存',
    cpuCores: 'CPU核心',
    currentQueueStatus: '当前队列状态',
    expressQueue: '快速队列',
    priorityQueue: '优先队列',
    standardQueue: '标准队列',
    economyQueue: '经济队列',
    adminDashboard: '管理员仪表板',
welcomeBack: '欢迎回来',
connectionDiagnostics: '连接诊断',
regionalQRPayment: '地区二维码支付',
createRenderJob: '创建渲染任务',
analyticsDashboard: '分析仪表板',
paymentSuccessful: '支付成功！',
queueStatus: '队列状态',
realTimeMonitoring: '渲染工作节点实时监控',
// Admin
adminDashboard: '管理员仪表板',
welcomeBack: '欢迎回来',
paymentVerificationQueue: '支付验证队列',
userManagement: '用户管理',
allCaughtUp: '全部完成！',
noPendingPayments: '目前没有待验证的支付',
paymentDetails: '支付详情',
adminActions: '管理员操作',
verificationNotes: '验证备注',
approve: '批准',
reject: '拒绝',
contactUserViaTelegram: '通过Telegram联系用户',

// Connection
testingConnection: '测试连接中...',
connectionIsWorkingWell: '连接工作正常',
recommendedSolutions: '推荐解决方案',
quickFixes: '快速修复',
refreshPage: '刷新页面',
clearCacheAndReload: '清除缓存并重新加载',
testBackendDirectly: '直接测试后端',

// Crypto Payment
chooseCryptocurrency: '选择加密货币',
selectPreferredCrypto: '选择您首选的支付加密货币',
popularAndRecommended: '热门和推荐',
otherOptions: '其他选项',
importantRequirements: '重要要求',
sendExactly: '准确发送',
paymentExpired: '支付已过期',
startOver: '重新开始',
creatingPaymentRequest: '创建支付请求中...',
sendExactlyThisAmount: '准确发送此金额：',
toThisWalletAddress: '到此钱包地址：',
enterTransactionHash: '输入交易哈希（发送后）：',
verifyPayment: '验证支付',
paymentConfirmed: '支付已确认！',
verifyingPayment: '验证支付中...',
paymentFailed: '支付失败',

// Worker & Queue
realTimeMonitoring: '渲染工作节点实时监控',
loadingQueueStatus: '加载队列状态中...',
unableToLoadQueueStatus: '无法加载队列状态',
processingPaused: '处理已暂停',
processingActive: '处理活跃',
queueTips: '队列提示',
expressQueueTip: '快速队列处理工作最快但费用更高',
economyQueueTip: '经济队列免费但可能需要更长等待时间',
cpuAndMemory: 'CPU和内存',
performanceOverTime: '随时间变化的性能',
activeJobs: '活跃任务',
renderStudio: '渲染工作室',
professionalBlenderRendering: '专业的云端Blender渲染。上传您的.blend文件，获得令人惊叹的结果。',
lightningFast: '闪电般快速',
powerfulGpuClusters: '强大的GPU集群渲染您的项目，比本地机器快10倍。',
cloudBased: '基于云端',
noExpensiveHardware: '无需昂贵的硬件。随时随地访问专业渲染能力。',
secureReliable: '安全可靠',
filesEncryptedSecure: '您的文件经过加密并安全存储。保证99.9%的正常运行时间。',
free: '免费',
forever: '永久',
threeRendersPerMonth: '每月3次渲染',
startFree: '免费开始',
pro: '专业版',
twintyRendersPerMonth: '每月20次渲染',
thirtyfiveRendersPerMonth:'每月35次渲染',
liveChatSupport: '在线聊天支持',
goPro: '升级专业版',
studio: '工作室版',
getStudio: '获取工作室版',
documentaryCreator: '纪录片创作者',
contentCreator: '内容创作者',
testimonial1: '渲染工作室改变了我的工作流程。过去需要几天的工作现在只需几小时！',
testimonial2: '质量令人难以置信，速度无与伦比。非常适合客户工作。',
testimonial3: '终于可以进行专业渲染而无需巨额硬件投资。',
heroDescription: '使用我们强大的云渲染平台，将您的Blender项目转换为令人惊叹的动画。无需昂贵的硬件，无需等待，只有结果。',
ancientRomeScene: '古罗马场景',
dnaVisualization: 'DNA可视化',
rendering67Percent: '渲染中 67%',
solarSystemTour: '太阳系漫游',
dragDropBlendFile: '只需拖放您的.blend文件。我们支持所有Blender版本和项目类型。',
chooseResolutionQuality: '选择您的分辨率、质量和优先级。我们的智能系统会处理其余部分。',
getNotifiedWhenComplete: '完成时获得通知，并在几分钟内下载高质量渲染，而不是几小时。',
simpleTransparentPricing: '简单透明的定价',
startFreeUpgrade: '免费开始，需要更多功能时升级',
mostPopular: '最受欢迎',
lovedByCreators: '深受创作者喜爱',
joinThousandsSatisfied: '加入数千名满意的用户',
readyToAccelerate: '准备加速您的3D工作流程？',
joinThousandsCreators: '加入已经转向云渲染的数千名创作者。',
startYourFreeTrial: '开始免费试用',
joinTenThousandCreators: '加入10,000+创作者',
professionalRenderingCloud: '专业的云端3D渲染',
transformCreativeVision: '使用我们强大的云渲染平台将您的创意愿景变为现实。',
joinCommunityForUpdates: '加入我们的社区获取更新、技巧和支持',
allRightsReserved: '保留所有权利。',
name:'姓名',
resolution:'解決',
duration: '时长',
created: '创建时间',
time: '时间',
status: '状态 & 操作',
logs: '日志',
totalrenders: '总渲染数',
completed: '已完成',
inprogress: '进行中',
failed: '失败',
quality:'品質',
preview: '预览',
renderingframe: '渲染帧',
videoerror: '您的浏览器不支持视频预览。',
waiting: '等待在',
queue: '队列中...',
renderfailed: '渲染失败',
chooseCryptocurrency: '选择加密货币',
  selectPreferredCrypto: '选择您首选的支付加密货币',
  cancel: '取消',
  payWith: '使用支付',
  reviewPaymentDetails: '查看支付详情',
  plan: '计划',
  usdAmount: '美元金额',
  cryptoAmount: '加密货币金额',
  paymentDetails: '支付详情',
  network: '网络',
  fees: '费用',
  confirmation: '确认',
  timeLimit: '时间限制',
  minutes: '分钟',
  important: '重要',
  sendExactly: '准确发送',
  useNetworkOnly: '仅使用网络',
  sendFromPersonalWallet: '从个人钱包发送',
  saveTransactionHash: '保存您的交易哈希',
  back: '返回',
  continue: '继续',
  sendPayment: '发送支付',
  payment: '支付',
  paymentExpired: '支付已过期',
  paymentExpiredDesc: '此支付请求已过期。请重新开始创建新的支付。',
  startOver: '重新开始',
  creatingPaymentRequest: '创建支付请求中...',
  sendExactlyThisAmount: '准确发送此金额：',
  mustBeExactAmount: '必须是准确金额 - 不多不少',
  toThisWalletAddress: '到此钱包地址：',
  networkOnly: '仅网络',
  quickPayment: '快速支付',
  scanQRCode: '使用您的钱包扫描此二维码：',
  orManualCopy: '或手动复制上方的金额和地址',
  enterTransactionHash: '输入交易哈希（发送后）：',
  pasteTransactionHash: '在此粘贴您的交易哈希...',
  transactionHashHelp: '发送支付后您将从钱包获得此信息',
  doubleCheckBeforeSending: '发送前请仔细检查：',
  usePersonalWallet: '从个人钱包发送（非交易所）',
  verifyWalletAddress: '验证钱包地址正确',
  verifying: '验证中...',
  verifyPayment: '验证支付',
  verifyingPayment: '验证支付中',
  transactionSubmitted: '您的交易已提交人工验证。通常需要5-10分钟。',
  viewTransaction: '查看交易',
  paymentConfirmed: '支付已确认！',
  subscriptionActivated: '您的订阅已激活。欢迎加入！',
  quickValidation: '快速验证',
  getVerifiedUnder10Min: '10分钟内完成验证',
  thankYouForPayment: '感谢您的支付！为了更快处理，您可以将交易截图发送到我们的Telegram。',
  usuallyVerifiedWithin: '通常在10分钟内验证',
  sendScreenshotToTelegram: '发送截图到Telegram',
  orContinueToDashboard: '或继续到仪表板（验证将自动进行）',
  continueToDashboard: '继续到仪表板',
  paymentFailed: '支付失败',
  paymentFailedDesc: '我们无法验证您的支付。请检查您的交易哈希并重试。',
  tryAgain: '重试',
  settings: '设置',
  profile: '个人资料',
  subscription: '订阅',
  preferences: '偏好设置',
  security: '安全',
  profileInformation: '个人资料信息',
  firstName: '名字',
  lastName: '姓氏',
  email: '邮箱',
  youtubeChannel: 'YouTube频道',
  optional: '可选',
  saveChanges: '保存更改',
  saving: '保存中...',
  currentPlan: '当前计划',
  rendersRemainingThisMonth: '本月剩余渲染次数',
  resetsOn: '重置于',
  active: '激活',
  availablePlans: '可用计划',
  mostPopular: '最受欢迎',
  current: '当前',
  month: '/月',
  perRender: '每次渲染',
  currentPlanButton: '当前计划',
  upgradeTo: '升级到',
  multiplePaymentOptions: '多种支付选项',
  paymentOptionsDesc: '我们接受USDT（TRC-20）加密货币、PayPal和地区二维码支付，实现快速、安全的交易。选择最适合您的支付方式。',
  language: '语言',
  currentLanguage: '当前',
  emailNotifications: '邮件通知',
  renderCompletionNotifications: '渲染完成通知',
  weeklyUsageReports: '每周使用报告',
  marketingUpdates: '营销更新',
  savePreferences: '保存偏好设置',
  securitySettings: '安全设置',
  currentPassword: '当前密码',
  newPassword: '新密码',
  confirmNewPassword: '确认新密码',
  updatePassword: '更新密码',
  updating: '更新中...',
  profileUpdatedSuccessfully: '个人资料更新成功！',
  passwordUpdatedSuccessfully: '密码更新成功！',
  subscriptionUpgradedSuccessfully: '订阅升级成功！',
  newPasswordsDoNotMatch: '新密码不匹配',
  passwordMustBe6Chars: '密码必须至少6个字符',
  channelUrlPlaceholder: '频道URL或用户名',
  plan: '计划',
  makesure: '确保所有纹理都打包在您的.blend文件中',
  filesize: '文件大小应小于100MB',
  supported: '仅支持.blend文件',
supported: '仅支持.blend文件',
  seconds: '秒',
  minutes: '分钟',
  rendercost: '基础渲染费用',
  free: '免费',
  freerender: '免费渲染',
  availablerenders: '此渲染将使用您可用渲染点数中的1个。',
  creating: '创建中...',
  upgradeTo: '升级到',
  payWithUSDT: '使用USDT加密货币支付',
  plan: '计划',
  price: '价格',
  paymentMethod: '支付方式',
  usdtTrc20: 'USDT（TRC-20）',
  sendPaymentUsing: '使用Tron网络（TRC-20）上的USDT发送支付',
  paymentCompleted30Min: '支付必须在30分钟内完成',
  needTronWallet: '您需要一个Tron钱包或交易所账户',
  transactionFeesLow: '交易费用通常非常低（1-2 USDT）',
  importantRequirements: '重要要求：',
  sendExactly: '准确发送',
  useTronNetworkOnly: '仅使用Tron网络（TRC-20）',
  sendFromPersonalWallet: '从个人钱包发送（非交易所）',
  keepTransactionHash: '保留您的交易哈希以供验证',
  continueWithUSDT: '使用USDT继续',
  cancel: '取消',
  sendUSDTPayment: '发送USDT支付',
  paymentExpired: '支付已过期',
  paymentExpiredDesc: '此支付请求已过期。请重新开始创建新的支付。',
  startOver: '重新开始',
  creatingPaymentRequest: '创建支付请求中...',
  sendExactlyThisAmount: '准确发送此金额：',
  mustBeExactAmount: '必须是准确金额 - 不多不少',
  toThisWalletAddress: '到此钱包地址：',
  tronNetworkOnly: '仅限Tron网络（TRC-20）',
  quickPayment: '快速支付',
  scanQRWithWallet: '使用您的Tron钱包扫描此二维码：',
  orManuallyCopy: '或手动复制上方的金额和地址',
  enterTransactionHash: '输入交易哈希（发送后）：',
  pasteTransactionHash: '在此粘贴您的交易哈希...',
  transactionHashFromWallet: '发送支付后您将从钱包获得此信息',
  doubleCheckBeforeSending: '发送前请仔细检查：',
  verifyWalletAddress: '验证钱包地址正确',
  saveTransactionHash: '保存您的交易哈希',
  verifying: '验证中...',
  verifyPayment: '验证支付',
  paymentConfirmed: '支付已确认！',
  verifyingPayment: '验证支付中...',
  paymentFailed: '支付失败',
  paymentStatus: '支付状态',
  congratsSubscriptionActive: '订阅现已激活。您可以立即开始使用新功能。',
  verifyingTransaction: '我们正在Tron区块链上验证您的交易。这通常需要1-5分钟。请稍候...',
  couldntVerifyPayment: '我们无法验证您的支付。请检查您的交易哈希并重试，如果问题仍然存在，请联系支持。',
  checkingPaymentStatus: '检查支付状态中...',
  transactionHash: '交易哈希：',
  view: '查看',
  whatsNext: '下一步是什么？',
  subscriptionImmediatelyActive: '您的订阅立即激活',
  newRenderQuota: '已应用新的渲染配额',
  premiumFeaturesAvailable: '高级功能现已可用',
  higherQualityUnlocked: '更高质量的渲染已解锁',
  continueToDashboard: '继续到仪表板',
  commonIssues: '常见问题：',
  incorrectTransactionHash: '交易哈希不正确',
  wrongAmountSent: '发送金额错误',
  wrongNetwork: '网络错误（仅使用TRC-20）',
  transactionStillPending: '交易仍在等待中',
  tryAgain: '重试',
  verificationInProgress: '验证进行中...',
  checkingBlockchain: '我们正在检查Tron区块链以查找您的交易。此过程是自动的，通常在5分钟内完成。',
  closeVerificationContinues: '关闭（验证将在后台继续）',
  upgradeYourSubscription: '升级您的订阅',
  choosePerfectPlan: '选择适合您渲染需求的完美计划。所有计划包括无限项目上传、云存储和24/7技术支持。',
  currentPlan: '当前计划',
  resetOn: '重置于',
  mostPopular: '最受欢迎',
  current: '当前',
  month: '/月',
  perRender: '每次渲染',
  currentPlanButton: '当前计划',
  upgradeTo: '升级到',
  planComparison: '计划比较',
  feature: '功能',
  basic: '基础版',
  pro: '专业版',
  studio: '工作室版',
  monthlyRenders: '每月渲染次数',
  maxResolution: '最大分辨率',
  queuePriority: '队列优先级',
  apiAccess: 'API访问',
  frequentlyAskedQuestions: '常见问题',
  canChangePlans: '我可以随时更改计划吗？',
  canChangePlansAnswer: '是的，您可以随时升级或降级您的计划。更改立即生效。',
  whatHappensUnused: '未使用的渲染会怎样？',
  whatHappensUnusedAnswer: '未使用的渲染不会结转到下个月。您的渲染配额每月重置。',
  howRefundsWork: '退款如何运作？',
  howRefundsWorkAnswer: '我们为所有订阅计划提供7天无理由退款保证。',
  maybeLater: '稍后再说',
  youAlreadyHaveThisPlan: '您已经拥有此计划',
  subscriptionUpgradedSuccessfully: '订阅升级成功！',
  renderQueueManagement: '渲染队列管理',
  systemLoad: '系统负载',
  resumeProcessing: '恢复处理',
  pauseProcessing: '暂停处理',
  systemPaused: '队列处理系统目前已暂停。在恢复之前，不会启动新的渲染。',
  queueDistribution: '队列分布',
  estimatedWaitTimes: '预估等待时间',
  min: '分钟',
  minutes: '分钟',
  jobsInQueue: '队列中的任务',
  activeRenders: '活跃渲染',
  queueSummary: '队列摘要',
  avgWait: '平均等待',
  loadingQueueData: '加载队列数据中...',
  queueDataError: '队列数据错误',
  retry: '重试',
  noActiveRenders: '目前没有活跃的渲染',
  jobName: '任务名称',
  user: '用户',
  started: '开始时间',
  progress: '进度',
  estCompletion: '预计完成',
  backend: '后端',
  totalJobs: '总任务数',
  renderAnalytics: '渲染分析',
  performanceMetrics: '性能指标和使用统计',
  averageRenderTime: '平均渲染时间（分钟）',
  renderTypes: '渲染类型',
  minutes: '分钟',
  count: '数量',
  jan: '1月',
  feb: '2月',
  mar: '3月',
  apr: '4月',
  may: '5月',
  jun: '6月',
  jul: '7月',
  historical: '历史',
  scientific: '科学',
  dataViz: '数据可视化',
  nature: '自然',
  space: '太空',
   payWithPayPal: '使用PayPal支付',
  paymentRequiresVerification: '支付需要人工验证（通常5-10分钟）',
  processingPayment: '处理支付中...',
  chooseDifferentPaymentMethod: '选择其他支付方式',
  securePaymentPoweredBy: '由PayPal提供的安全支付。管理员将在10分钟内验证支付。',
  paymentSubmittedVerification: '支付已提交验证！交易：',
  paypalPaymentFailed: 'PayPal支付失败：',
  paymentWasCancelled: '支付已取消',
  month: '/月',
  createRenderJob: '创建渲染任务',
  uploadBlendFile: '上传Blend文件',
  uploadingFile: '上传文件中...',
  fileUploaded: '文件已上传',
  configureRenderJob: '配置渲染任务',
  projectName: '项目名称',
  durationSeconds: '时长（秒）',
  resolution: '分辨率',
  quality: '质量',
  priority: '优先级',
  creatingRenderJob: '创建渲染任务中...',
  fileUploadedSuccessfully: 'Blend文件上传成功！',
  uploadFailed: '上传失败',
  pleaseUploadFileFirst: '请先上传.blend文件！',
  renderJobCreatedSuccessfully: '渲染任务创建成功！',
  createRenderJobFailed: '创建渲染任务失败',
   rendersPerMonth8: '每月8次渲染',
  rendersPerMonth20: '每月20次渲染',
  rendersPerMonth35: '每月35次渲染',
  resolution1080p: '1080p分辨率',
  resolution4K: '4K分辨率',
  resolution4KPlus: '4K+分辨率',
  standardQueue: '标准队列',
  priorityQueue: '优先队列',
  expressQueueNextInLine: '快速队列（下一个）',
  emailSupport: '邮件支持',
  prioritySupport: '优先支持',
  dedicatedSupport: '专属支持',
  startYourJourneyBasic: '开始您的基础计划之旅',
  getStartedWith8Renders: '开始使用',
  rendersPerMonthStrong: '每月8次渲染',
  forJust: '仅需',
  upgradeToProStudio: '升级到专业版（20次渲染）或工作室版（35次渲染）以获得更好的价值！',
  hdResolution: '高清分辨率',
  standardQueue: '标准队列',
  emailSupport: '邮件支持',
  choosePlan: '选择计划',
  allSystemsOperational: '所有系统正常运行',
  systemPerformanceDegraded: '系统性能下降',
  systemIssuesDetected: '检测到系统问题',
  dashboard: '仪表板',
  myRenders: '我的渲染',
  newRender: '新建渲染',
  settings: '设置',
  workerStatus: '工作节点状态',
  paymentVerification: '支付验证',
  queueOrderTip:'任務處理順序依優先順序排序：優先處理→高優先級→標準優先級→普通優先級',
  processingTimeTip:'處理時間取決於專案複雜程度和目前系統負載情況。'
  }
};

// Create the context
const LanguageContext = createContext();

// Language provider component
export const LanguageProvider = ({ children }) => {
  // Enhanced state management with error handling
  const [language, setLanguage] = useState(() => {
    try {
      // Try to get from localStorage first
      const saved = localStorage.getItem('renderStudioLanguage');
      
      // Validate the saved language
      if (saved && (saved === 'en' || saved === 'zh')) {
        console.log(`🌐 Loaded saved language: ${saved}`);
        return saved;
      }
      
      // Fallback to browser language detection
      const browserLang = navigator.language || navigator.userLanguage;
      if (browserLang.startsWith('zh')) {
        console.log('🌐 Detected Chinese browser language, setting to zh');
        return 'zh';
      }
      
      console.log('🌐 Defaulting to English');
      return 'en';
    } catch (error) {
      console.warn('Error loading language preference:', error);
      return 'en';
    }
  });

  // Save language preference when it changes
  useEffect(() => {
    try {
      localStorage.setItem('renderStudioLanguage', language);
      console.log(`💾 Language preference saved: ${language}`);
      
      // Dispatch custom event for other components that might need to know
      window.dispatchEvent(new CustomEvent('languageChanged', { 
        detail: { language, isEnglish: language === 'en' } 
      }));
    } catch (error) {
      console.warn('Failed to save language preference:', error);
    }
  }, [language]);

  // Enhanced toggle function with logging
  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'zh' : 'en';
    console.log(`🔄 Language toggle: ${language} → ${newLanguage}`);
    setLanguage(newLanguage);
  };

  // Function to set specific language
  const setLanguageDirectly = (lang) => {
    if (lang === 'en' || lang === 'zh') {
      console.log(`📝 Setting language directly: ${language} → ${lang}`);
      setLanguage(lang);
    } else {
      console.warn(`Invalid language code: ${lang}. Must be 'en' or 'zh'`);
    }
  };

  // Enhanced translation function with better fallback
  const t = (key, fallback = null) => {
    // Get value from current language
    const value = translations[language]?.[key];
    if (value) {
      return value;
    }
    
    // Fallback to English if current language doesn't have the key
    if (language !== 'en') {
      const englishValue = translations.en?.[key];
      if (englishValue) {
        // Only log in development mode
        if (process.env.NODE_ENV === 'development') {
          console.warn(`Translation missing for '${key}' in ${language}, using English`);
        }
        return englishValue;
      }
    }
    
    // Return fallback or the key itself
    if (fallback !== null) {
      return fallback;
    }
    
    // Log missing translation only in development
    if (process.env.NODE_ENV === 'development') {
      console.warn(`Missing translation for: '${key}'`);
    }
    
    return key;
  };

  // Helper properties
  const isEnglish = language === 'en';
  const isChinese = language === 'zh';
  const currentLanguageName = isEnglish ? 'English' : '中文';

  // Context value with all necessary properties
  const value = {
    language,
    setLanguage: setLanguageDirectly,
    toggleLanguage,
    t,
    isEnglish,
    isChinese,
    currentLanguageName,
    translations: translations[language],
    availableLanguages: [
      { code: 'en', name: 'English', flag: '🇺🇸', nativeName: 'English' },
      { code: 'zh', name: 'Chinese', flag: '🇨🇳', nativeName: '中文' }
    ]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Enhanced hook with error boundary
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;